<template>
  <div class="flex justify-center my-7.5">
    <h1 class="font-medium">
      {{ price }}
    </h1>
    <div class="text-lg mt-2">
      €
    </div>
    <div class="text-base self-end text-center mb-4">
      HT
    </div>
    <div class="text-xl self-end text-center mb-3 ml-3">
      /an
    </div>
  </div>
</template>
<script>
export default {
  props: {
    price: {
      type: Number,
      required: true
    }
  }
};
</script>